/**
 * Default hero for generic training provider onboarding.
 */
export default function TrainingProviderOnboardingHero() {
  return (
    <section className="hero-bg py-16 md:py-24 text-center relative overflow-hidden">
      <div className="absolute inset-0 bg-black bg-opacity-75" />
      <div className="container mx-auto px-6 relative z-10 max-w-4xl">
        <p className="text-green-400 text-sm font-semibold uppercase tracking-wide mb-3">
          For training providers
        </p>
        <h1 className="text-4xl md:text-5xl font-extrabold leading-tight">
          Understand <span className="gradient-text">Fit-Match</span> in
          minutes
        </h1>
        <p className="mt-6 text-lg md:text-xl text-gray-300">
          What the platform is, how clients, professionals, and communities use
          it — and how your graduates get{" "}
          <strong className="text-white">
            6 months of Full Membership free
          </strong>{" "}
          to kick-start their careers.
        </p>
        <div className="mt-8 inline-block bg-green-900/40 border border-green-600/50 rounded-xl px-6 py-4 text-left max-w-xl mx-auto">
          <p className="text-green-100 font-semibold text-sm md:text-base">
            Partnership costs your organisation nothing. You gain a tangible perk
            to offer every cohort: six months on the full pro plan, so new
            qualifiers can list, message, book, and get paid without the usual
            subscription cost while they find their feet.
          </p>
        </div>
      </div>
    </section>
  );
}
